export const MESSAGES: Messages = {
  CREATE: {
    SUCCESS: {
      variant: "default",
      description: "Arquivo D-TEF processado com sucesso!",
      duration: 5000,
      closeOnClick: true,
    },
    ERROR: {
      variant: "destructive",
      description: "Arquivo inválido. Verifique se contém as colunas: Loja, Data e NSU.",
      duration: 5000,
      closeOnClick: true,
    },
  },
  UPDATE: {
    SUCCESS: {
      variant: "default",
      description: "Validação D-TEF atualizada com sucesso!",
      duration: 5000,
      closeOnClick: true,
    },
    ERROR: {
      variant: "destructive",
      description: "Erro ao atualizar validação D-TEF.",
      duration: 5000,
      closeOnClick: true,
    },
  },
  DISABLED: {
    SUCCESS: {
      variant: "default",
      description: "Operação realizada com sucesso na validação D-TEF!",
      duration: 5000,
      closeOnClick: true,
    },
    ERROR: {
      variant: "destructive",
      description: "Erro ao realizar a operação na validação D-TEF.",
      duration: 5000,
      closeOnClick: true,
    },
  },
};
